<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Pokazuj strzałkę',
              modelPath: [this, 'form', 'show_arrow']
            }),
            new fields.Input({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'header'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst',
              type: 'textarea',
              modelPath: [this, 'form', 'text'],
              required: true,
              multilingual: true
            }),
            new fields.Link({
              label: 'Link',
              modelPath: [this, 'form', 'link'],
              required: false,
              internalOnly: true,
              hideLinkLabel: true
            })
          ]
        }
      ]
    }
  }
}
</script>
